import {Directive, ElementRef, EventEmitter, Input, Output} from '@angular/core';
import {CONFIG} from "../app/config";

@Directive({
    selector: '[blinkBG]'
})
export class BlinkBgDirective {

    private _element: HTMLElement;
    private _oldBgColor: string;

    private _si: number;

    @Output('blinkBG') private cmds: EventEmitter<any> = new EventEmitter();
    @Input('blinkBGColor') private _color: string = CONFIG.colors.CorVerm;

    constructor(element: ElementRef) {

        this._element = element.nativeElement;

    }

    ngAfterViewInit() {

        this.cmds.emit(this);

    }

    blink(totalBlink: number = 1, time: number = 300) {

        this._oldBgColor = window.getComputedStyle(this._element).backgroundColor;
        this._element.style.transitionDuration = time + 'ms';

        let count = 0;

        if (this._si) {
            clearInterval(this._si);
        }

        this._si = setInterval(() => {

            if (this._element.style.backgroundColor == this._oldBgColor) {
                this._element.style.backgroundColor = this._color;
            }
            else {
                this._element.style.backgroundColor = this._oldBgColor;
            }

            if (++count == totalBlink * 2) {
                clearInterval(this._si);
                this._element.style.backgroundColor = this._oldBgColor;
            }

        }, time);

    }

}



// WEBPACK FOOTER //
// ./src/directives/blink-bg.ts